<script lang="ts">

</script>


<style>
    :root {
        --underline-animation-time: 1s;
    }

    #welcome {
        display: grid;
        align-content: center;
        justify-content: center;

        /* Todo: Find way to color based on variable */
        background-image: url("./../background_waves.svg");
        background-position: 0% 50%;
        background-size: cover;
        background-repeat: repeat;
        background-color: rgba(0, 0, 0, 0.25);
    }

    #logo {
        margin: auto;
        width: 20rem;
        height: 20rem;
    }

    #logo path {
        fill: var(--button-foreground-color);
    }

    #h2-container {
        text-align: center;
        margin: auto;
    }

    h2 {
        font-size: 3rem;
        overflow: hidden;
    }

    #hey::after {
        content: "👋";
        margin-left: 1rem;
        display: inline-block;
        animation: 1s wave-animation calc(var(--underline-animation-time) + 500ms) infinite;
    }

    #hook {
        font-size: 1.5rem;
        position: relative;
    }

    #hook::after {
        content: "";
        position: absolute;
        width: 75%;
        height: 3px;
        transform: scaleX(0);
        bottom: -20%;
        left: 12.5%;
        background-color: var(--button-foreground-color);
        transform-origin: center;
        animation: var(--underline-animation-time) underline-animation 500ms forwards;
    }
    
    @keyframes underline-animation {
        to {
            transform: scaleX(1);
        }
    }

    @keyframes wave-animation {
        from {
            transform: rotate(0deg);
        }

        50% {
            transform: rotate(21deg);
        }

        to {
            transform: rotate(0deg);
        }
    }
</style>


<div class="info-container" id="welcome">
    <svg width="328" height="368" viewBox="0 0 328 368" xmlns="http://www.w3.org/2000/svg" id="logo">
         <g>
            <path id="logo-path" d="M134.015 82.5174C137.643 121.896 143.026 161.079 148.566 200.225C155.324 245.741 162.326 291.223 169.81 336.626C171.043 343.938 172.35 351.238 173.65 358.539C176.091 372.248 195.478 368.796 193.038 355.087C191.753 347.869 190.46 340.652 189.241 333.423C181.78 288.167 174.801 242.833 168.064 197.465C162.61 158.937 157.331 120.373 153.687 81.6232C153.055 67.7128 133.383 68.607 134.015 82.5174Z"/>
            <path id="logo-path" d="M95.5772 233.886C97.5979 233.631 99.629 233.448 101.639 233.12C120.469 230.047 139.208 225.43 157.254 219.25C167.749 215.656 178.214 211.904 188.348 207.396C199.905 202.256 210.945 196.027 222.244 190.342C233.108 183.274 244.389 176.809 254.836 169.138C273.343 155.548 291.515 139.359 305.406 120.892C315.812 107.059 325.939 89.052 327.276 71.163C327.889 62.9531 325.176 54.8319 324.126 46.6664C319.359 39.4591 316.093 30.9932 309.825 25.0444C293.29 9.35003 270.982 3.12849 248.96 0.917283C220.119 -1.97867 185.507 2.35398 157.62 8.71109C141.491 12.3879 125.898 18.1124 110.037 22.813C74.6917 37.2926 64.1088 40.1281 32.069 58.6398C22.7372 64.0315 14.0258 70.4321 5.00424 76.3283C-6.64025 83.964 4.15833 100.432 15.8028 92.7961C24.2578 87.2322 32.4147 81.1865 41.1677 76.1044C71.7298 58.3597 81.9259 55.5919 115.663 41.6846C130.697 37.1734 145.476 31.7068 160.764 28.151C186.837 22.0869 217.798 18.126 244.805 20.1664C261.986 21.4646 279.966 25.614 293.847 36.5554C298.335 40.0931 301.076 45.4088 304.69 49.8355C305.863 55.3024 308.39 60.6479 308.209 66.2364C307.724 81.2555 299.276 96.2226 290.728 107.763C277.939 125.03 261.234 139.959 244.071 152.648C234.233 159.922 223.603 166.058 213.369 172.763C202.685 178.176 192.25 184.111 181.317 189.001C171.653 193.325 161.67 196.922 151.66 200.369C133.138 206.747 113.922 211.398 94.5422 214.22C80.6367 214.952 81.6717 234.618 95.5772 233.886V233.886Z"/>
        </g>
    </svg>
    <div id="h2-container">
        <h2 id="hey">Hey, I'm Pere</h2>
        <p id="hook">I do software development</p>
    </div>
</div>